import React from "react";
import { ListFilterIndicatorView } from "./view";
import { styles } from "./styles";

export class ListFilterIndicator extends React.Component {
  render() {
    return <ListFilterIndicatorView {...this.props} styles={styles} />;
  }
}
